import React from 'react'

export interface PlaceholderReviewsProps {
  children?: React.ReactNode
}

const PlaceholderReviews: React.FC<PlaceholderReviewsProps> = ({ children }) => {
  const placeholders = new Array(3).fill(0).map((_, i) => (
    <div key={i}>
      <div className='grid-x grid-padding-x padding-2'>
        <div className='cell small-12 medium-1'>
          <div className='content-placeholder profile-image-placeholder' />
        </div>
        <div className='cell small-12 medium-5 large-4'>
          <div className='content-placeholder name-placeholder' />
        </div>
        <div className='cell show-for-large large-2'>
          <div className='content-placeholder star-placeholder margin-bottom-05' />
          <div className='content-placeholder star-label-placeholder margin-bottom-05' />
        </div>
        <div className='cell small-12 medium-3 large-2'>
          <div
            className='content-placeholder star-label-placeholder margin-bottom-05 margin-right-05 display-inline-block'
          />
          <div
            className='content-placeholder star-placeholder margin-bottom-05 display-inline-block'
          />
          <div
            className='content-placeholder star-label-placeholder margin-bottom-05 margin-right-05 display-inline-block'
          />
          <div
            className='content-placeholder star-placeholder margin-bottom-05 display-inline-block'
          />
        </div>

        <div className='cell small-12 medium-3 large-2'>
          <div
            className='content-placeholder star-label-placeholder margin-bottom-05 margin-right-05 display-inline-block'
          />
          <div
            className='content-placeholder star-placeholder margin-bottom-05 display-inline-block'
          />
          <div
            className='content-placeholder star-label-placeholder margin-bottom-05 margin-right-05 display-inline-block'
          />
          <div
            className='content-placeholder star-placeholder margin-bottom-05 display-inline-block'
          />
        </div>
      </div>

      <div className='grid-x padding-horizontal-2'>
        <div className='cell medium-1 hide-small-only' />
        <div className='cell medium-11 small-12'>
          <div className='content-placeholder body-placeholder' />
        </div>
      </div>
    </div>
  ))

  return (
    <div className='review-placeholder-parent'>
      <div className='placeholder-backdrop'>{placeholders}</div>
      <div className='review-placeholder-children'>
        {children}
      </div>
    </div>
  )
}

export default PlaceholderReviews
